import { render } from "./HeroiconsSolidClipboardCheck.vue?vue&type=template&id=ea386eb8"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboardCheck.vue"]])

export default __exports__